import { Button, Form, Input } from 'antd';
import React from 'react';
import { IFormProps } from 'src/app/forms/form.config';

const AccountForm: React.FC<IFormProps> = ({ form, onFinish }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Form form={form} onFinish={onFinish} style={{ color: 'white' }}>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: '12px' }}>Account Name</span>
            <Form.Item
              style={{ padding: '0px' }}
              className="borderless"
              name="accountName"
              rules={[{ required: true, message: 'Account name is required!' }]}
            >
              <Input
                style={{ background: 'rgba(1, 18, 24, 0.8)', border: 'none' }}
                placeholder="e.g. Main Bank Account"
              />
            </Form.Item>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: '12px' }}>Account No</span>
            <Form.Item
              style={{ padding: '0px' }}
              className="borderless"
              name="accountNo"
              rules={[{ required: true, message: 'Account no is required!' }]}
            >
              <Input style={{ background: 'rgba(1, 18, 24, 0.8)', border: 'none' }} placeholder="e.g. 12345678" />
            </Form.Item>
          </div>
        </div>
      </Form>
      <Button
        onClick={() => form.submit()}
        style={{
          background: 'radial-gradient(circle at top left, #0d3b47, #031a21 60%)',
          marginLeft: 'auto',
          width: '70px',
          border: '1px solid rgba(255, 255, 255, 0.12)',
        }}
      >
        Save
      </Button>
    </div>
  );
};

export default AccountForm;
